/**
 * Styled Components - Created by gustavomedina on 04/05/18.
 */
import styled from 'styled-components'
import Select from 'antd/lib/select'
import Input from 'antd/lib/input'
import Icon from 'antd/lib/icon'
import {
  GRAY_LIGHT,
  RED,
  GRAY,
  GRAY_SOFT,
  GRAY_DARK,
  BLUE,
  WHITE,
  GRAY_STRONG,
  ORANGE
} from '../../theme/colors'

type SelectType = {
  selectWidth?: string
}

interface StyledProps {
  selected?: boolean
  withBorder?: boolean
  marginLeft?: string
  disabled?: boolean
  highlight?: boolean
}

export const Table = styled.div`
  table-layout: fixed;
  width: 100%;
  margin-top: var(--spacing-20);
  display: table;
  @media (max-width: 767px) {
    margin-top: var(--spacing-16);
  }
`

export const Body = styled.tbody``

type RowProps = {
  withColor?: boolean
  onlyRead?: boolean
  withTwoPieces?: boolean
  upgradeOne?: boolean
  isMobile?: boolean
  upgradeTwo?: boolean
  upgradeThree?: boolean
  lengthColor?: number
  secondary?: boolean
}

export const Row = styled.div`
  display: table-row;
  grid-template-columns: ${({
      withColor,
      onlyRead,
      withTwoPieces,
      upgradeOne,
      upgradeTwo,
      upgradeThree,
      isMobile,
      lengthColor
    }: RowProps) => {
    let upgrade = 0
    if (upgradeOne && !isMobile) {
      upgrade += 1 
    }
    if (upgradeTwo && !isMobile) {
      upgrade += 1
    }
    if (upgradeThree && !isMobile) {
      upgrade += 1
    }
    if (withColor) {
      return onlyRead ? 
        `${lengthColor}px 1fr 1fr 1fr 1fr${Array(upgrade + 1).join(' 1fr')}` : 
        `${lengthColor}px 1fr 1fr 1fr 1fr${Array(upgrade + 1).join(' 1fr')}`
    }
    return !withTwoPieces ? `repeat(${4 + upgrade}, 1fr)` : `repeat(${5 + upgrade}, 1fr)`
  }};
  grid-gap: ${({ withColor }: RowProps) => (withColor ? '10px' : '3px')};

  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  padding-top: 8px;
  ${({ secondary }: RowProps) => secondary ? `
    display: inline-grid;
    width: 300%;
  ` : ''}
  @media (max-width: 767px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12px;
    padding: 0 0 16px;
    &.personalization {
      grid-template-columns: 1fr;
    }
  }
`

export const HeaderRow = styled.div`
  display: table-header-group;
  grid-template-columns: ${({ 
    withColor,
    onlyRead,
    withTwoPieces,
    upgradeOne,
    upgradeTwo,
    upgradeThree,
    lengthColor
  }: RowProps) => {
    let upgrade = 0
    if (upgradeOne) {
      upgrade += 1 
    }
    if (upgradeTwo) {
      upgrade += 1
    }
    if (upgradeThree) {
      upgrade += 1
    }
    if (withColor) {
      return onlyRead ? 
        `${lengthColor}px 1fr 1fr 1fr 1fr${Array(upgrade + 1).join(' 1fr')}` : 
        `${lengthColor}px 1fr 1fr 1fr 1fr${Array(upgrade + 1).join(' 1fr')}`
    }
    return !withTwoPieces ? `repeat(${4 + upgrade}, 1fr)` : `repeat(${5 + upgrade}, 1fr)`
  }};
  grid-gap: ${({ withColor }: RowProps) => (withColor ? '10px' : '8px')};
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${GRAY_SOFT};
  padding-bottom: 4px;
  @media (max-width: 1280px) {
    display: ${({ upgradeOne, upgradeTwo, upgradeThree }: RowProps) => 
      upgradeOne && upgradeTwo && upgradeThree ? 'flex' : 'table-header-group'};
    width: 100%;
  }
  @media (max-width: 767px) {
    display: none;
  }
`

export const Column = styled.td`
  outline: 1px solid red;
  padding: 0;
`
interface CellProps {
  width?: string
  align?: string
  start?: number
  end?: number
}
export const Cell = styled.div`
  display: table-cell;
  align-items: center;
  justify-content: center;
  text-align: left;
  padding-right: 12px;
  padding-bottom: 12px;
  grid-column-start: ${({ start }: CellProps) => start || 'unset'};
  grid-column-end: ${({ end }: CellProps) => end || 'unset'};
  flex-flow: ${({ align }: CellProps) => align || 'row'};
  width: ${({ width }: CellProps) => (width ? width : `100%`)};
  @media (max-width: 767px) {
    display: flex;
    flex-flow: column;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding: 0;
    gap: 8px;
  }
`

export const CellRemove = styled.div`
  display: table-cell;
  align-items: center;
  justify-content: center;
  text-align: left;
  padding-right: 12px;
  padding-bottom: 12px;
  grid-column-start: ${({ start }: CellProps) => start || 'unset'};
  grid-column-end: ${({ end }: CellProps) => end || 'unset'};
  flex-flow: ${({ align }: CellProps) => align || 'row'};
  width: ${({ width }: CellProps) => (width ? width : `100%`)};
  @media (max-width: 767px) {
    display: none;
  }
 `

export const RightInput = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 767px) {
    width: 100%; 
  }
`

export const Personalization = styled.div`
  display: flex;
  gap: var(--spacing-12);
  margin-block: var(--spacing-12);
  @media (max-width: 767px) {
    flex-flow: column;
    margin-bottom: 0;
  }
`

export const InfoCell = styled.div`
  width: 100%;
  display: table-cell;
  text-align: ${({ align }: CellProps) => (align ? align : 'left')};
  color: ${GRAY_DARK};
  grid-column-start: ${({ start }: CellProps) => start || 'unset'};
  grid-column-end: ${({ end }: CellProps) => end || 'unset'};
  font-size: 14px;
  padding-bottom: 10px;
  @media (max-width: 767px) {
    display: flex;
    flex-flow: column;
    max-width: 164px;
    padding-bottom: 8px;
    width: fit-content;
    margin-right: 20px;
  }
`

export const HeaderCell = styled.div`
  text-align: left;
  width: ${({ width }: CellProps) => (width ? width : '100%')};
  display: table-cell;
  vertical-align: bottom;
  padding-bottom: var(--spacing-6);
  @media (max-width: 767px) {
    display: auto;
  }
`

interface TitleProps {
  align: string
  titleWidth?: string
}

export const Title = styled.div`
  color: var(--neutral-darkest);
  font: 600 12px/20px var(--font-barlow);
  letter-spacing: 1px;
  text-transform: uppercase;
  text-align: ${({ align }: TitleProps) => align};
  width: ${({ titleWidth }: TitleProps) => (titleWidth ? titleWidth : 'auto')};
`

export const Price = styled.div`
  color: ${GRAY_DARK};
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 43px;
  width: 58px;
  text-align: ${({ align }: TitleProps) => (align ? align : 'center')};
`

export const UpgradeTitle = styled.div`
  color: ${GRAY_STRONG};
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 23px;
  text-align: left;
  display: flex;
  width: auto;
  word-break: break-all;
`

export const InfoBody = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-left: -38px;
`

export const InfoBodyModern = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
`

export const VariableTitle = styled.div`
  color: var(--neutral-secondary);
  font: 400 12px/18px var(--font-inter);
  margin-right: var(--spacing-8);
  white-space: nowrap;
`

export const InfoTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  text-align: center;
`

export const InfoIcon = styled(Icon)`
  margin-right: 12px;
`

export const InfoDescription = styled.div`
  margin-top: 28px;
  center {
    font-size: 16px;
  }
  ul {
    padding-left: 15px;
    margin-bottom: 0;
    margin-top: 18px;
  }
`

export const InfoImage = styled.img`
  max-width: 75vw;
  border-radius: 5px;
  width: 100%;
  @media (max-width: 768px) {
    max-width: 886px;
    margin-top: 0px;
  }
`

export const InfoURL = styled.a`
  color: ${BLUE};
`

export const buttonStyle = {
  background: WHITE,
  color: GRAY_DARK,
  borderColor: GRAY_LIGHT,
  boxShadow: 'none'
}

export const buttonStyleModern = {
  background: WHITE,
  color: 'black',
  border: '1px solid black',
  fontWeight: 600,
  width: '28px',
  padding: 0,
  borderRadius: '25px',
  height: '28px',
}

export const maskBlurred = {
  backdropFilter: 'blur(3px)'
}

export const MobileEmtpytable = styled.div`
  padding: 50px 40px 50px;
  border-bottom: 1px solid ${GRAY_LIGHT};
  color: ${GRAY};
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 21px;
  text-align: center;
`

export const DeleteItem = styled(Icon)`
  color: var(--neutral-dark-gray);
  cursor: pointer;
  margin-left: 4px;
  &.mobileDelete {
    display: none;
  }
  @media (max-width: 767px) {
    &.mobileDelete {
      display: block;
      margin-left: 12px;
      font-size: 16px;
    }
  }
`

export const DeleteItemMobile = styled.div`
  color: ${ORANGE};
  cursor: pointer;
  text-align: right;
  display: none;
  width: 100%;
  justify-content: flex-end;
  flex: 1;
  font-size: 12px;
  @media (max-width: 1000px) {
    display: flex;
  }
  @media (max-width: 698px) {
    justify-content: center;
  }
`

export const StyledSelect = styled(Select)`
  width: ${({ selectWidth }: SelectType) => selectWidth ? selectWidth : '20%'};
  .ant-select-selection {
    border-color: var(--neutral-border-med);
    border-radius: 0;
    height: 42px;
    transition: all .25s;
    &:hover, &:focus, &:active {
      border-color: var(--neutral-darkest);
      box-shadow: none;
      outline: none;
    }
  }
  .ant-select-selection__rendered {
    margin-inline: 16px;
    font: 400 14px / 40px var(--font-inter);
  }
  .ant-select-selection__placeholder {
    color: var(--neutral-muted);
  }
  .ant-select-arrow {
    color: var(--neutral-darkest);
  }
  .ant-select-selection-selected-value {
    color: var(--neutral-darker);
  }

  transition: all .25s;
  &.invalid-field {
    .ant-select-selection {
      background: #fff3f3;
      border-color: ${RED};
    }
    animation: pulse 1s 0.5s 2;
    @keyframes pulse {
      0% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 1));
        transform: scale(1);
        .ant-select-selection {
          background: #fff3f3 !important;
        }
      }
      70% {
        filter: drop-shadow(0 0 20px rgba(255, 0, 0, 0));
        transform: scale(1.05);
        .ant-select-selection {
          background: white !important;
        }
      }
      100% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 0));
        transform: scale(1);
        .ant-select-selection {
          background: #fff3f3 !important;
        }
      }
    }
  }
  @media (max-width: 767px) {
    width: 100%;
  }
`

export const StyledInput = styled(Input)`
  width: 188px;
  border-radius: 0;
  padding: var(--spacing-4) var(--spacing-16);
  height: 42px;
  &::placeholder {
    color: var(--neutral-muted);
    font: 300 14px/22px var(--font-inter);
    font-style: italic;
  }
  @media (max-width: 767px) {
    width: 100%;
  }
`

export const Divider = styled.div`
  display: table-row;
  .line {
    border-top: var(--border-regular) solid var(--neutral-border-light);
    width: 100%;
    margin-block: var(--spacing-4) var(--spacing-16);
  }
  &:last-child { 
    display: none;
  }
`

export const QtyBtn = styled.div`
  width: 38px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1.25px solid var(--neutral-border-med);
  color: var(--neutral-darkest);
  font: 600 16px/22px var(--font-barlow);
  letter-spacing: -0.1px;
  transition: background-color .15s, border-color .25s;
  &:hover {
    cursor: pointer;
    border-color: var(--neutral-darkest);
  }
  &:active {
    background-color: var(--neutral-darkest);
    color: var(--neutral-white);
  }
`

export const StyledInputNumber = styled.input`
  width: 42px;
  height: 42px;
  border: unset;
  border-top: 1.25px solid var(--neutral-border-med);
  border-bottom: 1.25px solid var(--neutral-border-med);
  color: var(--neutral-darkest);
  text-align: center;
  display: flex;
  align-items: center;
  font: 600 16px/22px var(--font-barlow);
  letter-spacing: -0.1px;
  /* Disable browser default arrow styles */
  appearance: textfield;
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  transition: all .25s;
  &.invalid-field {
    border-color: ${RED};
    background: #fff3f3;
    animation: pulse 1s 0.5s 2;
    @keyframes pulse {
      0% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 1));
        transform: scale(1);
        background: #fff3f3 !important;
      }
    
      70% {
        filter: drop-shadow(0 0 20px rgba(255, 0, 0, 0));
        transform: scale(1.05);
        background: white !important;
      }
    
      100% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 0));
        transform: scale(1);
        background: #fff3f3 !important;
      }
    }
  }
`

export const ProductColor = styled.img`
  border-radius: 50%;
  border: 1px solid ${GRAY};
  width: 30px;
`

export const QuestionSpan = styled.span`
  margin-inline: 8px 20px;
  background: var(--neutral-border-light);
  color: #4A4A48;
  text-align: center;
  font: 700 10px / 14px var(--font-barlow);
  padding: 2px 7px;
  border-radius: 50px;

  &::after {
    content: '?';
  }
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 767px) {
    margin-inline: 6px 0;
    margin-bottom: 0;
  }
`

export const CellContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ align }: CellProps) => align || 'flex-start'};
  .limitLabel {
    font-size: 12px;
    background: #fff4e0;
    padding: 2px 6px;
    border-radius: 3px;
    margin-left: 8px;
    white-space: nowrap;
    @media (max-width: 1080px) {
      margin-left: -64px;
      margin-top: -56px;
    }
  }
  .optional-case {
    color: var(--neutral-secondary);
    font: 400 14px/22px var(--font-inter);
    margin-left: -8px;
    @media (max-width: 767px) {
      margin-left: 8px;
    }
  }
`

export const QuantityDiv = styled.div`
  padding-inline: var(--spacing-6);
  margin-left: var(--spacing-8);
  text-align: center;
  border-radius: 50px;
  background: var(--neutral-dark-gray);
  color: var(--neutral-white);
  font: 600 14px/20px var(--font-inter);
`

export const ColorOption = styled.div`
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 28px;
  padding: 0px 10px;
  transition: all .25s;
`

interface DivProps {
  secondary?: boolean
}

export const ColorName = styled.div`
  z-index: 2;
  color: #b0b0b0;
  font-size: 11px;
  mix-blend-mode: difference;
  white-space: nowrap;
  ${({ secondary }: DivProps) => secondary ? `
    color: ${WHITE};
    mix-blend-mode: unset;
  ` : ''};
`

export const ProductAvailableColor = styled.img`
  position: absolute;
  z-index: 1;
  object-fit: cover;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 25px;
  transition: all .25s;
  box-shadow: 1px 2px 2px 0px #e1e1e1;
  border: ${({ selected, withBorder }: StyledProps) =>
    selected
      ? `2px solid #ff99a9`
      : (withBorder ? `1px solid ${GRAY_DARK}` : 'none')};
`

export const TitleMobile = styled.div`
  color: var(--neutral-darkest);
  font: 600 12px/20px var(--font-barlow);
  letter-spacing: 1px;
  text-transform: uppercase;
  text-align: left;
  width: 100%;
  align-items: center;
  display: none;
  @media (max-width: 767px) {
    display: flex;
    .limitLabel {
      font-size: 11px;
      background: #fff4e0;
      padding: 4px;
      border-radius: 3px;
      margin-left: 6px;
      white-space: nowrap;
      align-self: center;
      line-height: 1;
      font-weight: normal;
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CartListItemTableV2/styledComponents.tsx